import React, { Component } from "react";
import { DKLabel, showAlert, DKIcon } from "deskera-ui-library";
import { TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import { showFormPopup } from "./AddNewRecordPopup";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { DealManager } from "../../managers/DealManager";
import ContactManager from "../../managers/ContactManager";
import FormManager from "../forms/FormManager";
import CampaignManager from "../campaign/CampaignManager";
import LandingPageManager from "../landing_pages/LandingPageManager";
import { PRODUCT_ICON } from "../common/Dashboard/DashboardCard";
import FormsTemplateManager from "../forms/templates/TemplateManager";
import CampaignTemplateManager from "../campaign/templates/TemplateManager";
import LandingPageTemplateManager from "../landing_pages/templates/TemplateManager";
import JobPipelineService from "../common/Dashboard/JobPipeline";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

class AddNewList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const list = [
      {
        title: "Candidate",
        icon: PRODUCT_ICON[TABLES.CANDIDATE],
        show: PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.VIEW])
      },
      {
        title: "Job Pipeline",
        icon: PRODUCT_ICON[TABLES.JOB_PIPELINE],
        show: PermissionUtils.hasAccess(MODULE.JOB_PIPELINE, [ACTION.VIEW])
      },
      {
        title: "Job Form",
        icon: PRODUCT_ICON[TABLES.JOB_FORMS],
        show: PermissionUtils.hasAccess(MODULE.JOB_FORM, [ACTION.VIEW])
      }
    ];

    return (
      <div
        className="column bg-white border-radius-s border-m shadow-m position-absolute pb-s"
        style={{ top: 40, right: -5, width: 150, zIndex: 9999 }}
      >
        <DKLabel text="Create New" className="fw-m fs-m pt-r pb-s p-h-s" />
        {list.filter(obj => obj.show).map((obj, index) => {
          return (
            <div
              className="row listPickerBG cursor-hand parent-width border-box"
              style={{ padding: 12 }}
              onClick={() => {
                this.navigateToCreate(index);
                this.props.onClose();
              }}
            >
              <DKIcon src={obj.icon} className="ic-s" />
              <DKLabel text={obj.title} className="ml-r" />
            </div>
          );
        })}
      </div>
    );
  }

  navigateToCreate(index) {
    switch (index) {
      case 0:
        showFormPopup({
          tableName: TABLES.CANDIDATE,
          defaultValues: ContactManager.getDefaultValues(),
          displayName: TABLES.CONTACT,
          inputData: JobPipelineService.getPipelineData(JobPipelineService.pipelineData),
          popupClass: 'custom-scroll'
        });
        break;
      case 1:
        showFormPopup({
          tableName: TABLES.JOB_PIPELINE,
          defaultValues: DealManager.getDefaultValues(),
          displayName: TABLE_DISPLAY_NAME[TABLES.JOB_PIPELINE],
        });
        break;
      case 2: {
        FormManager.setFormData(null);
        FormsTemplateManager.setSelectedTemplateId(null);
        RouteManager.navigateToPage(PAGE_ROUTES.SELECT_FORM_TEMPLATE);
        break;
      }
      case 3: {
        CampaignManager.setPageData(null);
        CampaignTemplateManager.setSelectedTemplateId(null);
        RouteManager.navigateToPage(PAGE_ROUTES.SELECT_CAMPAIGN_TEMPLATE);
        break;
      }
      case 4: {
        LandingPageManager.setPageData(null);
        LandingPageTemplateManager.setSelectedTemplateId(null);
        RouteManager.navigateToPage(PAGE_ROUTES.SELECT_LANDING_PAGE_TEMPLATE);
        break;
      }
      case 5: {
        RouteManager.navigateToPage(PAGE_ROUTES.FUNNEL_SELECTION);
        break;
      }
      default:
        showAlert("Cell tapped ", "Index- " + index);
        break;
    }
    this.props.onClose();
  }
}

export default AddNewList;
